import { Avatar } from '#src/components/avatar/Avatar/index.tsx';
import { ASSETS_HOST } from '#src/constants/assets.ts';

type Props = {
  league: {
    name: string;
    slug: string;
    avatarUrl?: string | null;
  };
  className?: string;
  size?: number;
};

const getLeagueAvatarUrl = (slug: string) =>
  `${ASSETS_HOST}/competition/picture/icons/${slug}.png`;

export const LeagueAvatar = ({
  league: { name, slug, avatarUrl: leagueAvatarurl },
  ...rest
}: Props) => {
  const avatarUrl = leagueAvatarurl || getLeagueAvatarUrl(slug);
  return <Avatar name={name} avatarUrl={avatarUrl} {...rest} />;
};
